import { PurhcaseRequestDetails } from "../models/PurchaseRequest/PurchaseRequestDetails";

export const PO_TERMINAL_STATUSES = ["CANCELLED", "CLOSED"] as const;

export function isPoCancelledOrClosed(status?: string | null): boolean {
  if (!status) return false;
  return (PO_TERMINAL_STATUSES as readonly string[]).includes(status);
}

/** True when a PO is still open (CREATED/OPEN), using purchase_orders when active_po is absent. */
function hasActivePurchaseOrder(detail: PurhcaseRequestDetails): boolean {
  if (Number(detail.active_po) === 1) return true;
  return (detail.purchase_orders ?? []).some(
    (po) => po.status === "CREATED" || po.status === "OPEN",
  );
}

export function getPrLinkedPurchaseOrder(
  detail: PurhcaseRequestDetails | null | undefined,
) {
  const orders = detail?.purchase_orders ?? [];
  if (orders.length === 0) return undefined;

  if (detail?.po_id && detail.po_id > 0) {
    const byPoId = orders.find((po) => po.id === detail.po_id);
    if (byPoId) return byPoId;
  }

  return (
    orders.find((po) => isPoCancelledOrClosed(po.status)) ??
    orders[orders.length - 1]
  );
}

export function getResolvedPoId(
  detail: PurhcaseRequestDetails,
): number | undefined {
  return getPrLinkedPurchaseOrder(detail)?.id ?? undefined;
}

/** Edit allowed before first PO, or after PO cancel/close with permission. */
export function canEditPrProductFields(
  detail: PurhcaseRequestDetails,
  hasPostPoEditPermission: boolean,
): boolean {
  if (detail.pr_cancellation_date || detail.active === 0) return false;
  if (!detail.purchase_orders || detail.purchase_orders.length === 0) return true;
  if (!hasPostPoEditPermission) return false;
  if (hasActivePurchaseOrder(detail)) return false;
  const linkedPo = getPrLinkedPurchaseOrder(detail);
  return isPoCancelledOrClosed(linkedPo?.status);
}

export function canReactivatePurchaseOrder(
  detail: PurhcaseRequestDetails,
  hasPostPoEditPermission: boolean,
): boolean {
  if (!canEditPrProductFields(detail, hasPostPoEditPermission)) return false;
  const linkedPo = getPrLinkedPurchaseOrder(detail);
  return Boolean(linkedPo && isPoCancelledOrClosed(linkedPo.status));
}
